import { styled } from '@mui/material/styles';

export const NoDateWrapper = styled('div')(
  () => `
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`,
);

export const ImageWrapper = styled('div')(
  ({ theme }) => `

  margin-bottom: ${theme.DS_spacing(['xxs'])};
  img {
   width: 50%;
   margin: 0 auto;
  }

`,
);

export const ClosestLocations = styled('div')(
  ({ theme }) => `
  margin-bottom: ${theme.DS_spacing(['sm'])};
  h3 {
  margin-bottom: ${theme.DS_spacing(['xs'])}
  }
  
   ${theme.breakpoints.up('md')} {
   h3 {
    margin: ${theme.DS_spacing(['xxs'])} 0;
   }
  }
`,
);

export const StyledLocationButton = styled('div')(
  ({ theme }) => `
  margin-bottom: ${theme.DS_spacing(['md'])};
  height: 100%;
  width: 100%; 
  > div { 

    &:hover {
      background-color: ${theme.DS_palette.background.lightBlue};
    }
  }
  ${theme.breakpoints.up('lg')} {
   > div { 
      height: 100%;
      > div { 
      height: 100%;
      }
   }
  }

`,
);

export const StyledLocationsCardsWrapper = styled('div')(
  ({ theme }) => `
  
     ${theme.breakpoints.up('md')} {
      display: flex;
      flex-direction: column;
      align-items: center;
   
     }
  
    ${theme.breakpoints.up('lg')} {
    margin-top: ${theme.DS_spacing(['lgx'])};
     display: grid;
     grid-template-columns: repeat(3, 1fr);
     grid-auto-rows: 1fr;
     gap: ${theme.DS_spacing(['sm'])};

 
 }
`,
);
